import { useState } from "react"
import API from "../config/api"

const useMutation = (url, method = "POST") => {
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const mutate = async (body) => {
    setLoading(true)
    setError(null)
    setData(null)
    try {
      const res = await fetch(`${API}${url}`, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
      if (!res.ok) {
        const text = await res?.text()
        if (text) {
          throw new Error(text)
        } else {
          throw new Error(`Request failed: ${res.status}`)
        }
      }
      const result = await res.json()
      setData(result)
      return result
    } catch (err) {
      setError(err.message)
      throw err
    } finally {
      setLoading(false)
    }
  }

  return { mutate, data, loading, error }
}

export default useMutation
